import * as React from "react";
import Box from "../box";
import { BreadcrumbProps } from "./breadcrumb.types";

function Breadcrumb(props: BreadcrumbProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={props.gapRight}
      width={props.width}
      mt={props.mt}
      mb={props.mb}
    >
      {props.children}
    </Box>
  );
}

Breadcrumb.defaultProps = {
  width: {
    tablet: "90%",
    desktop: "80%",
  },
  gapRight: "22px",
};

export default Breadcrumb;
